import { AwsRum } from 'aws-rum-web';
import {
  getApplicationId,
  getSessionApplicationId
} from 'shared/utils/applicationId';

import {
  CLOUDWATCH_RUM_MONITOR_ENABLED,
  CLOUDWATCH_RUM_CONFIG_GUEST_ROLE_ARN,
  CLOUDWATCH_RUM_CONFIG_IDENTITY_POOL_ID,
  CLOUDWATCH_RUM_CONFIG_ENDPOINT,
  CLOUDWATCH_RUM_CONFIG_ALLOW_COOKIES,
  CLOUDWATCH_RUM_CONFIG_ENABLE_XRAY,
  CLOUDWATCH_RUM_APPLICATION_ID,
  CLOUDWATCH_RUM_APPLICATION_VERSION,
  CLOUDWATCH_RUM_APPLICATION_REGION
} from 'shared/config';

const DEFAULT_SESSION_SAMPLE_RATE = 1;
const DEFAULT_SESSION_EVENT_LIMIT = 2000;

export let awsRum;
export const init = () => {
  if (!CLOUDWATCH_RUM_MONITOR_ENABLED) return;

  try {
    const config = {
      sessionEventLimit: DEFAULT_SESSION_EVENT_LIMIT,
      sessionSampleRate: DEFAULT_SESSION_SAMPLE_RATE,
      guestRoleArn: CLOUDWATCH_RUM_CONFIG_GUEST_ROLE_ARN,
      identityPoolId: CLOUDWATCH_RUM_CONFIG_IDENTITY_POOL_ID,
      endpoint: CLOUDWATCH_RUM_CONFIG_ENDPOINT,
      telemetries: [
        ['http', { stackTraceLength: 500 }],
        ['errors', { stackTraceLength: 500 }],
        'performance'
      ],
      allowCookies: CLOUDWATCH_RUM_CONFIG_ALLOW_COOKIES,
      enableXRay: CLOUDWATCH_RUM_CONFIG_ENABLE_XRAY,
      sessionAttributes: {
        loan_application_id: getApplicationId() || getSessionApplicationId()
      }
    };

    awsRum = new AwsRum( // eslint-disable-line no-unused-vars
      CLOUDWATCH_RUM_APPLICATION_ID,
      CLOUDWATCH_RUM_APPLICATION_VERSION,
      CLOUDWATCH_RUM_APPLICATION_REGION,
      config
    );
    console.info(
      `Initialized CW RUM with following config: ${JSON.stringify(config)}`
    );
  } catch (error) {
    // Ignore errors thrown during CloudWatch RUM web client initialization
    console.warn(`CW RUM init failed: ${JSON.stringify(error)}`);
  }
};
